import { searchCodes } from './SearchCodes';
//技术领域
const codes = searchCodes
  .find((_) => _.code == '02')
  .childs.map((_) => {
    return {
      data: _.code,
      name: _.name,
    };
  });
export const techs = [{ name: '全部', data: '' }, ...codes].slice(0, codes.length);

//常州地区
export const areas = [
  {
    name: '全部',
    data: '',
  },
  {
    name: '市辖区',
    data: '320401',
  },
  {
    name: '经开区',
    data: '320472',
  },
  {
    name: '科教城',
    data: '320403',
  },
  {
    name: '天宁区',
    data: '320402',
  },
  {
    name: '钟楼区',
    data: '320404',
  },
  {
    name: '新北区',
    data: '320411',
  },
  {
    name: '武进区',
    data: '320412',
  },
  {
    name: '金坛区',
    data: '320413',
  },
  {
    name: '溧阳市',
    data: '320481',
  },
];

export const czHomePath = '/branch/changzhou';

//需求状态
export const status = [];
